// extracted by mini-css-extract-plugin
module.exports = {"list":"list--1jFdi","listMake":"listMake--3-twM","ant-tabs-nav":"ant-tabs-nav--23zX_","col":"col--2mZg0","label":"label--3Aggh","colRight":"colRight--3MJ6J"};